export const productsSlugs = {
  BRUSH: 'brush',
  BRUSH_AGAVE: 'brush_agave',
  BRUSH_BOAR: 'brush_boar',
  BRUSH_DETANGLING: 'brush_detangling',
  BRUSH_MIXED: 'brush_mixed',
  COMPLETE_SET: 'complete_set',
  CONDITIONER: 'conditioner',
  CONDITIONER_COARSE: 'conditioner_coarse',
  CURL_CREAM: 'curl_cream',
  DIGITAL_GIFT: 'digital_gift',
  DRY_SHAMPOO: 'dry_shampoo',
  ESSENTIALS_SET: 'essentials_set',
  GIFT: 'gift',
  GIFT_WITH_PURCHASE: 'gwp',
  HAIR_MASK: 'hair_mask',
  HAIR_OIL: 'hair_oil',
  LEAVEIN_CONDITIONER: 'leavein_conditioner',
  MASK: 'mask',
  OIL: 'leavein',
  SCALP_MASK: 'scalp_mask',
  SHAMPOO: 'shampoo',
  SHIMMER_HAIR_OIL: 'shimmer_hairoil',
  SUPPLEMENT_CORE: 'supplement_core',
  SUPPLEMENTS_POUCH: 'supplements_pouch',
  TRIAL_CONDITIONER: 'trial_conditioner',
  TRIAL_SHAMPOO: 'trial_shampoo',
  STYLING_GEL: 'styling_gel',
};

export const products = [
  productsSlugs.CONDITIONER,
  productsSlugs.CURL_CREAM,
  productsSlugs.DRY_SHAMPOO,
  productsSlugs.HAIR_MASK,
  productsSlugs.LEAVEIN_CONDITIONER,
  productsSlugs.OIL,
  productsSlugs.SCALP_MASK,
  productsSlugs.SHAMPOO,
  productsSlugs.SUPPLEMENT_CORE,
];

export const productsLabels = {
  [productsSlugs.HAIR_MASK]: 'Pre-Shampoo Hair Mask',
  [productsSlugs.SCALP_MASK]: 'Pre-Shampoo Scalp Mask',
  [productsSlugs.SHAMPOO]: 'Shampoo',
  [productsSlugs.CONDITIONER]: 'Conditioner',
  [productsSlugs.LEAVEIN_CONDITIONER]: 'Leave-In Conditioner',
  [productsSlugs.DRY_SHAMPOO]: 'Dry Shampoo',
  [productsSlugs.OIL]: 'Hair Oil',
  [productsSlugs.CURL_CREAM]: 'Curl Cream',
  [productsSlugs.SUPPLEMENT_CORE]: 'Root Source™ Hair Supplements',
};

export const haircareProducts = [
  productsSlugs.HAIR_MASK,
  productsSlugs.SCALP_MASK,
  productsSlugs.SHAMPOO,
  productsSlugs.CONDITIONER,
  productsSlugs.DRY_SHAMPOO,
  productsSlugs.OIL,
  productsSlugs.CURL_CREAM,
  productsSlugs.LEAVEIN_CONDITIONER,
];

export const productsWithFragrance = [
  productsSlugs.HAIR_MASK,
  productsSlugs.SHAMPOO,
  productsSlugs.CONDITIONER,
  productsSlugs.LEAVEIN_CONDITIONER,
  productsSlugs.CURL_CREAM,
];

/**
 * Categories
 */

export const productsCategories = {
  COUPON: 'coupon',
  FORMULA: 'formula',
  GIFT: 'gift',
  ITEM: 'item',
  HAIRCARE: 'haircare',
  HAIRCARE_RETURNING_PROSPECT: 'haircare_returning_prospect',
  SUPPLEMENTS: 'supplements',
};

/**
 * Prices
 */

export const productsPrices = {
  [productsSlugs.CURL_CREAM]: 26,
  [productsSlugs.CONDITIONER]: 28,
  [productsSlugs.DRY_SHAMPOO]: 26,
  [productsSlugs.HAIR_MASK]: 42,
  [productsSlugs.LEAVEIN_CONDITIONER]: 26,
  [productsSlugs.OIL]: 48,
  [productsSlugs.SCALP_MASK]: 42,
  [productsSlugs.SHAMPOO]: 28,
  [productsSlugs.SUPPLEMENT_CORE]: 52,
};
